import { useAutoAnimate as useFormKitAutoAnimate } from '@formkit/auto-animate/react';

function useAutoAnimate({ duration = 150, easing = 'ease-in-out' } = {}) {
  const [parent, enableAnimations] = useFormKitAutoAnimate({
    duration,
    easing,
  });

  return [parent, enableAnimations];
}

export default useAutoAnimate;
